export default __webpack_public_path__ + "static/media/logo-initial.c7cb68af.png";